import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})

export class PageMetaService {
    private favicons = [
        {
            name: 'default',
            href: 'assets/icons/favicon.ico'
        },
        {
            name: 'elite_rugby_app',
            href: 'assets/icons/favicon-elite-rugby-app.png'
        },
        {
            name: 'hyper_system',
            href: 'assets/icons/favicon-hyper-system.png'
        }
    ];

    private favicon: HTMLLinkElement;

    constructor(private titleService: Title) {
        this.favicon = document.querySelector("link[rel*='icon']") || document.createElement('link');
        this.favicon.type = 'image/x-icon';
        this.favicon.rel = 'shortcut icon';
        document.getElementsByTagName('head')[0].appendChild(this.favicon);
    }

    setPageMeta(title: string, faviconName: string = 'default') {
        this.titleService.setTitle(title);
        const favicon = this.favicons.find(f => f.name === faviconName);
        this.favicon.href = favicon ? favicon.href : this.favicons[0].href;
    }
}
